import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "nprogress/nprogress.css";
import NProgress from "nprogress";
import "./registerServiceWorker";
import mathquill from "katex";
import Chartkick from "vue-chartkick";
import Chart from "chart.js";
import Snackbar from "vuejs-snackbar";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import dayjs from "dayjs";
import { App as AppC } from "@capacitor/app";
import refreshLogin from "./mixings/refreshLogin";
import imageUpload from "./mixings/imageUpload";
import testConfigs from "./mixings/testConfigs";
import utils from "./mixings/utils";
import VueOtp2 from "vue-otp-2";
import ToastService from "primevue/toastservice";
import PrimeVue from "primevue/config";
import Toast from "primevue/toast";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';


// import VueTelInput from 'vue-tel-input';
// import 'vue-tel-input/dist/vue-tel-input.css';


Vue.component("Toast", Toast);
Vue.use(PrimeVue);
Vue.component("snackbar", Snackbar);
Vue.use(Chartkick.use(Chart));
Vue.use(VueOtp2);
Vue.use(ToastService);
//Vue.use(require("vue-moment"));
Vue.use(mathquill);
Vue.use(NProgress);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(dayjs);
Vue.mixin(refreshLogin);
Vue.mixin(imageUpload);
Vue.mixin(utils);
Vue.mixin(testConfigs);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);
// Vue.use(VueTelInput);
//CKEditor.plugins.addExternal('ckeditor_wiris', '../node_modules/@wiris/mathtype-ckeditor4/plugin.js');

AppC.addListener("backButton", () => {
  if (history.length > 0) {
    history.back();
  } else {
    AppC.exitApp();
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,

  created() {
    /*var self = this;
                    window.onbeforeunload = function(e) {
                        if (self.$route.path == "/select") {
                            e = e || window.event;
                            //old browsers
                            if (e) { e.returnValue = 'Changes you made may not be saved'; }
                            //safari, chrome(chrome ignores text)
                            return 'Changes you made may not be saved';
                        } else {
                            return null;
                        }
                    };
                    if (performance.navigation.type == 1) {
                        if (this.$route.path == '/select') {
                            this.$router.push({ path: "/select" })
                        } else {
                            console.log('reload page without redirect');
                        }
                    }

                    */
  },
  render: h => h(App)
}).$mount("#app");
